<template>
	<div class="page-order page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">库存列表</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>库存管理</el-breadcrumb-item>
							<el-breadcrumb-item>库存列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="desk_number" label="所属店铺：">
						    <el-select size="small" filterable v-model="form_search.desk_number" placeholder="请选择">
						        <el-option
						                v-for="item in init_data.desk_list"
						                :key="item.number"
						                :label="item.name"
						                :value="item.number">
						        </el-option>
						    </el-select>
						</el-form-item>
						<el-form-item prop="stock_number" label="商品名称：">
						    <el-select size="small" filterable v-model="form_search.stock_number" placeholder="请选择">
						        <el-option
						                v-for="item in init_data.stock_list"
						                :key="item.stock_number"
						                :label="item.name"
						                :value="item.stock_number">
						        </el-option>
						    </el-select>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="desk_number" align="center" label="店铺编码" min-width="160">
							</el-table-column>
							<el-table-column prop="stock_number" align="center" label="商品编码" min-width="160">
							</el-table-column>
							<el-table-column prop="desk_name" align="center" label="所属仓库" min-width="160">
							</el-table-column>
							<el-table-column prop="product_name" align="center" label="商品名称" min-width="160">
							</el-table-column>
							<el-table-column prop="stock_count" align="center" label="库存数量" min-width="160">
								<template slot-scope="scope">
									<span>{{scope.row.stock_count}}{{ scope.row.stock_count > 0 ? scope.row.unit : ''}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="lock_count" align="center" label="占用数量" min-width="160">
								<template slot-scope="scope">
									<span>{{scope.row.lock_count}}{{ scope.row.lock_count > 0 ? scope.row.unit : ''}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="usable_count" align="center" label="可用数量" min-width="160">
								<template slot-scope="scope">
									<span>{{scope.row.usable_count}}{{ scope.row.usable_count > 0 ? scope.row.unit : ''}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="use_count" align="center" label="使用数量" min-width="160">
								<template slot-scope="scope">
									<span>{{scope.row.use_count}}{{ scope.row.use_count > 0 ? scope.row.unit : ''}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="operating" align="right" label="操作" min-width="80" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-m" type="primary" size="mini"
										@click="stockDetail(scope.row.desk_number, scope.row.stock_number)">库存记录</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
				<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
					<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				init_data: {
					desk_list: [],
					stock_list: []
				},
				form_search: {
					stock_number: '',
					desk_number: '',
				},
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 10,
						total: 130
					}
				},
				dlg_preview: {
					visible: false,
					img_url: ''
				}
			}
		},
		created() {
			document.title = '库存列表';
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				var desk_default = [{number:'', name: '全部'}];
				var stock_default = [{stock_number:'', name: '全部'}];
				this.$client.get('/adminapi/stock/list', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.init_data.desk_list = desk_default.concat(res.desk_name_list);
					_this.init_data.stock_list = stock_default.concat(res.stock_product_name_list);
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			stockDetail(desk_number, stock_number){
				var data = {
				    desk_number:desk_number,
				    stock_number:stock_number,
				};
				this.$util.goTo('/stock/stocklog',{query:data})
			},
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(`当前页: ${val}`);
				this.table_data.page_info.page = val;
				this.getList();
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>

</style>
<style scoped>

</style>
